import styled from "styled-components";
import { media } from "./lib/styles/media";
import { motion } from "framer-motion";
import useObserver from "./lib/hook/useObserver";
import { customChildVariants, customVariants } from "./lib/styles/animation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import Chart from "./components/end/Chart";
import { CustomSeries } from "./interface/chart";

const Section = styled.section`
  width: 100%;
  min-height: 100vh;
  display: flex;
  gap: 25px;
  justify-content: space-between;
  box-sizing: border-box;
  align-items: center;
  position: relative;
  scroll-snap-align: start;

  ${media.phone`
    padding: 20px;
    flex-direction: column;
    justify-content: center;
    gap: 50px;
  `}
`;

const LeftBox = styled.div`
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;

  ${media.phone`
    width: 100%;
  `}
`;

const TextBox = styled(motion.div)`
  font-family: "S-CoreDream-9BLACK";
  font-size: 50px;
  color: #fff;
  position: relative;
  text-align: center;
  text-shadow: 0 0 6px #000000a8;

  ${media.phone`
    font-size: 40px;
  `}
`;

const SubTextBox = styled(motion.div)`
  font-size: 23px;
  text-shadow: 0 0 6px #000000a8;
  /* font-family: 'S-CoreDream-7EXTRA_BOLD'; */
  font-family: "S-CoreDream-3Light";

  ${media.phone`
    font-size: 18px;
  `}
`;

const RightBox = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${media.phone`
    width: 100%;
  `}
`;

// const GlassCard = styled.div`
//   background: rgba(255, 255, 255, 0.07);
//   backdrop-filter: blur(16px);
//   -webkit-backdrop-filter: blur(16px);
//   border: 1px solid rgba(255, 255, 255, 0.14);
//   box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
//   border-radius: 20px;
//   padding: 24px;
//   padding-right: 15px;

//   ${media.phone`
//     width: 100%;
//     box-sizing: border-box;
//   `}
// `;

const ChartBox = styled.div`
  width: 500px;
  height: 300px;
  font-family: "S-CoreDream-3Light";
  font-weight: 600;

  ${media.phone`
    width: 100%;
  `}
`;

const ChartTitle = styled.div`
  font-family: "S-CoreDream-7EXTRA_BOLD";
  color: #fff;
  font-size: 18px;
  display: flex;
  gap: 5px;
  justify-content: center;
`;

const ChartTitleToolTipBox = styled.div`
  position: relative;
`;

const ChartTitleToolTipIcon = styled(FontAwesomeIcon)``;

const CharTitleToolTip = styled.div`
  font-family: "S-CoreDream-3Light";
  position: absolute;
  display: none;
  font-size: 14px;
  font-weight: 600;
  background-color: #333333c1;
  padding: 5px 10px;
  border-radius: 5px;
  color: #fff;
  white-space: nowrap;
  top: -100%;
  left: 50%;
  transform: translate(-50%, -50%);

  ${ChartTitleToolTipBox}:hover & {
    display: flex;
  }
`;

// ================================================================
// 기본값
const defaultData: CustomSeries[] = [
  {
    id: "방문자",
    data: [
      {
        x: "2000-00-00",
        y: 0,
      },
    ],
  },
];

// const updateVisitor = async () => {
//   const today = getDate(0);
//   const storage = localStorage.getItem(today);
//   // 오늘 방문 이력 없음
//   if (!storage) {
//     await createDocument(today, { count: 1, date: today });
//     localStorage.setItem(today, "1");
//   }
// };

// // 방문자수 기록
// function useVisitor() {
//   const queryClient = useQueryClient();
//   return useMutation({
//     mutationFn: updateVisitor,
//     onSuccess: () => {
//       queryClient.invalidateQueries({ queryKey: ["visitor"] });
//     },
//     onError: (err) => {
//       console.error("방문자수 기록 중 오류 발생", err);
//     },
//   });
// }

// ================================================================

export default function End() {
  // ================================================================
  // 애니메이션 ref
  const { ref, animation } = useObserver();

  // ================================================================
  // 방문자수 get
  // const getData = async (): Promise<CustomSeries[]> => {
  //   const keys = getChartKey();
  //   const res = await getDocuments(keys[0], keys[keys.length - 1]);
  //   return res ? getChartData(res, keys) : defaultData;
  // };

  // ================================================================
  // tanstack query
  // 방문자수 get
  // const { data } = useQuery({
  //   queryKey: ["visitor"],
  //   queryFn: getData,
  //   staleTime: 1000 * 60 * 5,
  // });

  // const { mutate } = useVisitor();

  // ================================================================

  // useEffect(() => {
  //   mutate();
  // }, [mutate]);

  // ================================================================
  return (
    // 왼쪽 (인삿말) / 오른쪽 방문자수 차트
    <Section id="end">
      <LeftBox>
        <TextBox ref={ref} animate={animation} variants={customVariants}>
          THANK YOU
          <SubTextBox variants={customChildVariants}>
            끝까지 봐주셔서 감사합니다.
          </SubTextBox>
          <SubTextBox variants={customChildVariants}>
            함께할 날을 기다리고 있습니다.
          </SubTextBox>
        </TextBox>
      </LeftBox>
      <RightBox>
        <ChartBox>
          <ChartTitle>
            최근 방문자수
            <ChartTitleToolTipBox>
              <ChartTitleToolTipIcon icon={faCircleExclamation} />
              <CharTitleToolTip>
                nivo 그래프 라이브러리를 이용했습니다.
              </CharTitleToolTip>
            </ChartTitleToolTipBox>
          </ChartTitle>
          <Chart data={defaultData} />
          {/* <Chart data={data ?? defaultData} /> */}
        </ChartBox>
      </RightBox>
    </Section>
  );
}
